export default {
  name: "correspondence-reply"
};